import { useHistory } from "react-router";
import { useAppDispatch } from "../app/store";
import { setRedirectURL } from "../slices/applicationSlice";
import { SetSessionStorageItem } from "../utils/tableUtils";

interface UseTableStatePersistenceProps<T> {
  storageKey: string;
  requestDataSearch: T;
  tableState: any;
}

export const useTableStatePersistence = <T>({
  storageKey,
  requestDataSearch,
  tableState,
}: UseTableStatePersistenceProps<T>) => {
  const history = useHistory();
  const dispatch = useAppDispatch();

  const handleDetailsClicked = (id: number | undefined, editUrl: (id: number) => string) => {
    if (!id) return;

    dispatch(setRedirectURL(history.location.pathname));
    SetSessionStorageItem<T>(
      storageKey,
      requestDataSearch,
      tableState
    );
    history.push(editUrl(id));
  };

  return { handleDetailsClicked };
}; 